export const MAX_UNMARK_AS_MASTER_LIMIT = 100
